import { memo } from "react";
import PaymentsIcon from '@mui/icons-material/Payments';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const FinancialInformationLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.HighRiskMerchant].FinancialInformation}`}
        Icon={PaymentsIcon}
        {...props}
    >
        Financial Information
    </StepLabel>
);

export default memo(FinancialInformationLabel);
